"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _getUrlParams = _interopRequireDefault(require("../getUrlParams"));
function getDomain() {
  // get the last 2 segments of the hostname if the hostname ends with .com
  // this will ignore anyone connecting to a server via IP
  const match = /[^.]+\.com$/.exec(window.location.hostname);
  return match && match.length > 0 ? match[0] : window.location.hostname;
}
var _default = exports.default = function _default(cookieName) {
  let urlParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const localUrlParams = typeof urlParams === "string" ? [urlParams] : urlParams;
  const urlData = localUrlParams.reduce(function (acc, val) {
    if (acc !== "") {
      return acc;
    }
    const valueFromUrl = (0, _getUrlParams.default)(val, {
      firstParamOnly: true
    });
    if (valueFromUrl) {
      return valueFromUrl;
    }
    return acc;
  }, "");
  const cookieData = _jsCookie.default.get(cookieName);
  const getData = function () {
    return urlData || cookieData;
  };
  const setData = function (value) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _jsCookie.default.set(cookieName, value, {
      expires: 30,
      domain: getDomain(),
      ...opts
    });
  };
  if (urlData) {
    setData(urlData);
  }
  return [getData(), setData];
};